import { render } from "./OutletType.vue?vue&type=template&id=2e8d714d"
import script from "./OutletType.vue?vue&type=script&lang=js"
export * from "./OutletType.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\msimi\\Downloads\\WEB KIM\\pjp-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__